import { Client } from '@api/index'
import { ENDPOINTS } from './constants'
import { LogExperimentParams } from './types'
import { UnleashSDK } from './unleash.sdk'

/**
 * Logs an experiment event to the analytics service.
 * Skips on localhost unless enableAnalytics is explicitly true (same as @pw-tech/unleash).
 */
export const logExperiment = async ({
  flagName,
  variantName,
  context,
}: LogExperimentParams): Promise<void> => {
  const config = UnleashSDK.getConfig()
  const isLocal = typeof window !== 'undefined' && window.location.hostname === 'localhost'
  if (isLocal && !(config?.api?.enableAnalytics ?? false)) {
    return
  }

  const deviceId =
    (typeof window !== 'undefined' &&
      (localStorage.getItem('device_id') ||
        localStorage.getItem('uuid') ||
        localStorage.getItem('randomId'))) ||
    ''

  const payload = {
    experimentName: flagName,
    variantName,
    featureEnabled: true,
    platform: 'WEB',
    appVersion: config?.appVersion,
    ...(deviceId ? { userId: deviceId } : {}),
    ...(context ? { context } : {}),
  }

  const BASE_URL =
    process.env.REACT_APP_UNLEASH_ANALYTICS_URL ||
    process.env.REACT_APP_ANALYTICS_API_BASE_URL
  const endpoint = `${BASE_URL?.replace(/\/?$/, '/')}${ENDPOINTS.RECORD_EXPERIMENT}`

  try {
    const response = await Client.post(endpoint, payload, {})
    if (response?.data) {
      console.log('Ambassador: Experiment logged successfully')
    } else {
      console.warn(
        'Ambassador: Experiment logging failed (non-critical):',
        response?.status
      )
    }
  } catch (error) {
    console.warn(
      'Ambassador: Experiment logging error (non-critical):',
      error
    )
  }
}
